import {
  Component,
  OnInit,
  HostBinding,
  HostListener,
  Input
} from '@angular/core';

@Component({
  selector: 'awair-dropdown2-menu-checkbox',
  templateUrl: './dropdown-menu-checkbox.component.html',
  styleUrls: ['./dropdown-menu-checkbox.component.scss']
})

export class Dropdown2MenuCheckboxComponent implements OnInit {

  @HostListener('click', ['$event']) click(event: Event) {
    event.stopPropagation();
    // TODO: Implement dropdown mode
    if (!this.hasNoClickState) {
      this.hostChecked = !this.hostChecked;
    }
  }

  @HostBinding('class.--small') hostSmall: boolean = false;
  @HostBinding('class.--checked') hostChecked: boolean = false;

  @Input()
  set isSmall(value: boolean) {
    if (value != null) {
      this.hostSmall = value;
    }
  }

  @Input()
  set isChecked(value: boolean) {
    if (value != null) {
      this.hostChecked = value;
    }
  }

  @Input() hasNoClickState: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }
}
